import * as React from 'react';
import { ProductFilter, getSelectedProductCodes } from 'app/shared/model/ProductFilter';
import { SelectionOptionDisplay } from 'app/pages/DiscountEditor/components/ProductSelection/SelectionOptions';
import { Product } from 'app/shared/model';
import { UnitsFilter, UnitsFilterType } from 'app/shared/model/ProductUnitFilter';
import { productCodeAliases } from 'app/pages/DiscountEditor/modules/ProductSelection/selectors';

export interface ProductSelectionDisplayProps {
    productFilter: ProductFilter
    productMap: { [code: string]: Product|undefined }
    unitFilter?: UnitsFilter
    productOfferingHints?: { [productCode: string]: string }
}

function UnitsFilterDisplay(unitsFilter: UnitsFilter|undefined) {
    if (unitsFilter === undefined)
        return true;

    switch(unitsFilter.type) {
        case UnitsFilterType.None:
            return true;
        case UnitsFilterType.MaxUnits:
            return <p>The number of units (week) must be at most {unitsFilter.maxUnits}</p>;
        case UnitsFilterType.MinUnits:
            return <p>The number of units (week) must be at least {unitsFilter.minUnits}</p>;
        case UnitsFilterType.BetweenUnits:
            return <p>The number of units (week) must be between {unitsFilter.minUnits} and {unitsFilter.maxUnits}</p>;
        default:
            return true;
    }
}

function resolveProductName(productMap: { [code: string]: Product|undefined }, code: string): string {
    for (const alias of productCodeAliases(code)) {
        const product = productMap[alias];
        if (product?.name) return product.name;
    }
    return code || 'Unknown product';
}

function ProductsDisplay(props: ProductSelectionDisplayProps) {
    const products =
        Object.keys(getSelectedProductCodes(props.productFilter)).map(code => ({
            code,
            name: resolveProductName(props.productMap, code),
            hint: props.productOfferingHints?.[code],
        }))
    if (products.length === 0)
        return true;

    return <ul className="ui list">
        { products.map((p) => (
            <li key={p.code}>
                {p.name}
                {p.hint && (
                    <div style={{ fontSize: 12, color: 'rgba(0, 0, 0, 0.45)' }}>{p.hint}</div>
                )}
            </li>
        )) }
    </ul>;
}

export function ProductSelectionDisplay(props: ProductSelectionDisplayProps) {
    return <div>
        <SelectionOptionDisplay productFilter={props.productFilter} />
        {ProductsDisplay(props)}
        {UnitsFilterDisplay(props.unitFilter)}
    </div>;
}
